<div class="wrapper" [ngClass]="{'checkout-item': _variant === VARIANT_CHECKOUT_ITEM, 'cart-item': _variant === VARIANT_CART_ITEM}">
    <app-spinner *ngIf="loading"></app-spinner>
    <div class="container" *ngIf="!loading">
      <div class="item-contents flex">
        <div class="image-container">
          <img [src]="itemImage">
        </div>
        <div class="item-details flex-grow-1">
          <p class="title">{{feature._book.title}}</p>
          <p *ngIf="!feature.endPubDate">
            <span>Promo Date:</span> {{pubDate}}
          </p>
          <p *ngIf="feature.endPubDate">
            <span>Promo Date:</span> Starting on {{pubDate}}
          </p>
          <div class="expanded-details" *ngIf="detailsExpanded">
            <p><span>Promo Site:</span> {{feature._site.name}}</p>
            <p><span>Genre/Product:</span> {{feature._siteAdvert.name}}</p>
            <p><span>Book Price:</span> {{bookPrice}}</p>
          </div>
          <div class="edit-details">
            <a (click)="toggleDetails()">{{detailsExpanded ? 'Collapse Details' : 'Details'}}</a>
            <div class="dot">&#183;</div>
            <a (click)="editFeature()">Edit</a>
          </div>
        </div>
        <div class="flex align-items-end justify-content-end flex-direction-column">
          <p class="speculative-discount-orinal-price" *ngIf="hasSpeculativeDiscount">{{ feature._siteAdvert.price | currency:'USD' }}</p>
          <p class="total-amount">{{paymentAmount | currency:'USD'}}</p>
          <div class="speculative-discount" *ngIf="hasSpeculativeDiscount">{{ speculativeDiscountText }}</div>

          <div *ngIf="!hasSpeculativeDiscount && showMembershipSaving">
            <div *ngIf="qualifiesForMembershipUpsell" class="speculative-discount-upsell flex">
              <div class="gold">
                <div class="wwm-icon"></div>
              </div>
              {{ upsellText }}
            </div>
          </div>
        </div>
        
      </div>
      <div *ngIf="hasValidPromoCode() || (_variant === VARIANT_CART_ITEM && hasSpeculativeDiscount)" class="price-section">
        <div class="sub-section" *ngFor="let detail of discountDetails">
          <p>{{ detail.label }}</p>
          <p class="ml-10">{{ detail.value | currency:'USD' }}</p>
        </div>
        <div class="sub-section">
          <p>Promo Price</p>
          <p class="ml-10">{{ paymentAmount | currency:'USD' }}</p>
        </div>
      </div>
      <!-- <div class="cart-price flex">
        <div class="flex-grow-1"></div>
        <div class="speculative-discount" *ngIf="hasSpeculativeDiscount">{{ speculativeDiscountText }}</div>
        <p class="total-amount ml-10">${{paymentAmount?.toFixed(2)}}</p>
      </div> -->
      <div class="button regular close" (click)="openConfirmationModal()"><span class="icon">&#x00D7;</span></div>
    </div>
  </div>
  <app-confirm-modal
    [modalId]="modalId"
    [text]="confirmText"
    [buttonText]="buttonText"
    (confirmChoice)="onItemRemove($event)"
  ></app-confirm-modal>
<app-error-modal [modalId]="'cart-item-error-modal'" [text]="errorText"></app-error-modal>
